<template>
  <transition name="fade">
    <div class="Terms" v-if="visible">
      <img
        class="Terms-logo"
        ref="logo"
        src="@/assets/img/logo.svg"
        alt="Carta Blanca"
      />
      <div class="Terms-close" @click="$emit('close')" />
      <TycosText />
    </div>
  </transition>
</template>

<script>
import TycosText from "@/components/TycosText";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  components: {
    TycosText,
  },
};
</script>

<style lang="stylus" scoped>
@import 'Terms.styl';
</style>
